//Core Modules
import React, {Fragment} from 'react';

//User Defined
import Common from "../../Common/Common";
import ImportSteps from "./ImportSteps";
import ImportUpload from "./ImportUpload";

class Import extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            currentStep : 1
        };
    }

    render(){


        let {currentStep} = this.state;

        const steps =[
            'Upload Your File',
            'Choose an Action',
            'Map Your Data',
            'Additional Options',
        ];

        return (
            <Common pageTitle={"Import"} showLoader={false} mainContent={
                <Fragment>
                    <div className={`wp-container`}>
                        <div className={`wp-wrapper`}>
                            <ImportSteps steps={steps} currentStep={currentStep} />
                            {
                                currentStep === 1 &&
                                <ImportUpload/>
                            }
                        </div>
                    </div>
                </Fragment>
            }/>
        )
    }
}

export default Import